import React, {useLayoutEffect} from "react";
import './squadflix-trending-header.scss';
import ButtonV2 from "../../../shared/button-v2/button-v2";
import {cn} from "../../../../utils/utils";
import {SquadflixHeaderType} from "../../../user-app-config/hooks";
import SquadflixHeaderItem from "../squadflix-header-item/squadflix-header-item";
import useTrendingHeaderItems from "../../hooks/useTrendingHeaderItems";

const calcOffset = (selectedIndex: number, itemIndex: number, totalItems: number) => {
    let offset = itemIndex - selectedIndex;
    if (offset < -Math.floor(totalItems / 2)) {
        offset += totalItems;
    } else if (offset > Math.floor(totalItems / 2)) {
        offset -= totalItems;
    }
    return offset;
}

type Props = {
    headerType: SquadflixHeaderType;
}

const SquadflixTrendingHeader = ({headerType}: Props) => {
    const {
        allItems,
        tmdbTrendingMovies,
        loading,
        currentIndex,
        setCurrentIndex,
        nextSlide,
        prevSlide,
        openItem
    } = useTrendingHeaderItems(headerType, 5000);
    const headerRef = React.useRef<HTMLDivElement>(null);

    useLayoutEffect(() => {
        if (loading) return;
        const onWidthChange = () => {
            if (headerRef.current) {
                const width = headerRef.current.offsetWidth;
                if (width < 750) {
                    headerRef.current.classList.add('header-phone');
                } else {
                    headerRef.current.classList.remove('header-phone');
                }
            }
        };
        window.addEventListener('resize', onWidthChange);
        onWidthChange();
        return () => {
            window.removeEventListener('resize', onWidthChange);
        }
    }, [loading]);

    return (
        <div className="squadflix-trending-header" ref={headerRef}>
            <div className="squadflix-trending-header__content">
                {allItems.map((item: any, i) => {
                    const offset = calcOffset(currentIndex, i, allItems.length);
                    if (offset < -3 || offset > 3) return null;
                    const logoPath = item.logo_path ?? item.logoImageUrl;
                    return (
                        <SquadflixHeaderItem
                            className={cn({"selected-item": i === currentIndex})}
                            disabled={offset !== 0}
                            key={item.id + "_" + item.isMovie}
                            style={{
                                left: `${50 + offset * 85}%`,
                                zIndex: tmdbTrendingMovies.length - Math.abs(offset),
                            }}
                            backgroundUrl={item.backdrop_path ?? item.backgroundUrl}
                            logoImageUrl={logoPath}
                            title={logoPath ? undefined : (item.title || item.name)}
                            overlay={{
                                bottomLeft: item.bottomLeftOverlay ?? <>
                                    {item.media_type === "movie" ? "Película" : "Serie"} &#8226; {item.vote_average.toFixed(1)}
                                    <i className="fa-solid fa-star text-warning fa-sm"></i>
                                </>
                            }}
                            logoSubtitle={item.subtitle}
                            onClick={() => {
                                if (i !== currentIndex) {
                                    setCurrentIndex(i);
                                    return;
                                }
                                openItem(item);
                            }}/>
                    )
                })}
            </div>
            <ButtonV2 className="squadflix-trending-header__nav-button-left" onClick={prevSlide}>
                <i className="fa-solid fa-chevron-left"></i>
            </ButtonV2>
            <ButtonV2 className="squadflix-trending-header__nav-button-right" onClick={nextSlide}>
                <i className="fa-solid fa-chevron-right"></i>
            </ButtonV2>
        </div>
    );
}

export default SquadflixTrendingHeader;
